var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { cn } from 'hx-util';
import { StepLayout } from './step-layout.component';
import { pageImages } from '@/pages/images';
import { NavigationButton, NavigationButtonsContainer, } from './navigation-button.component';
export function InstructionsStep() {
    var _a = useState('START'), buttonText = _a[0], setButtonText = _a[1];
    var navigate = useNavigate();
    var timerRef = useRef(null);
    useEffect(function () {
        return function () {
            if (!timerRef.current)
                return;
            clearInterval(timerRef.current);
            timerRef.current = null;
        };
    }, []);
    function onNextClick() {
        if (buttonText !== 'START')
            return;
        var currentCount = 5;
        setButtonText("".concat(currentCount));
        timerRef.current = setInterval(function () {
            currentCount--;
            if (currentCount > 0) {
                setButtonText("".concat(currentCount));
                return;
            }
            if (timerRef.current) {
                clearInterval(timerRef.current);
                timerRef.current = null;
            }
            navigate('/din-test');
        }, 1000);
    }
    return (_jsx(StepLayout, { image: pageImages.officePeople, showProgress: false, heading: "Instructions pour le", subHeading: "test de d\u00E9pistage", content: _jsxs("div", __assign({ className: "flex w-full max-w-xl flex-col items-center gap-6 px-8" }, { children: [_jsx(Typography, __assign({ variant: "h5", className: "font-normal text-xl" }, { children: "Dans ce test, vous entendrez trois chiffres \u00E0 la fois. Les num\u00E9ros seront pr\u00E9sent\u00E9s avec un bruit de fond." })), _jsx(Typography, __assign({ variant: "h5", className: "font-normal text-xl" }, { children: "Entrez les chiffres que vous entendez et appuyez sur SUIVANT. Si vous n'entendez pas clairement les chiffres, devinez de votre mieux." }))] })), nav: _jsxs(NavigationButtonsContainer, { children: [_jsx(NavigationButton, { navigate: "/setup/volume", variant: "outlined", label: "Pr\u00E9c\u00E9dent", className: "py-2 text-xl" }), _jsx(NavigationButton, { onClick: onNextClick, variant: "outlined", label: buttonText === 'START' ? 'Suivant' : buttonText, className: cn('py-2 text-xl') })] }) }));
}
